import React from "react";
import { Link } from "react-router-dom";
import { Container, Typography, Paper, Box, Button } from "@mui/material";
import { PictureAsPdf } from "@mui/icons-material";

import doklad from "../assets/pdf/Doklad_2026.pdf";

const ReportPage = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Paper elevation={2} sx={{ p: 4, mb: 4 }}>
        <Typography variant="h5" gutterBottom>
          Доклад "Читалищната мрежа в България – анализ през призмата на
          данните"
        </Typography>

        <Typography paragraph>
          Докладът "Читалищната мрежа в България – анализ през призмата на
          данните" представя детайлен прочит на данните, събрани в рамките на
          проекта. На над 40 страници документът разглежда състоянието на
          читалищния сектор през призмата на статистиката, икономиката и
          демографията, като предлага за първи път толкова мащабен сравнителен
          анализ на общинско ниво.
        </Typography>

        <Box sx={{ mt: 4, mb: 4 }}>
          <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
            Какво съдържа докладът?
          </Typography>

          <Box component="ul" sx={{ pl: 2 }}>
            <Box component="li" sx={{ mb: 2 }}>
              <Typography paragraph>
                Детайлно описание на подхода при събирането на данни, работата с ГИС координати при създаването на{" "}
                <Link
                  to="https://karta.narodnichitalishta.bg/"
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    fontWeight: "bold",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 0.5,
                    textDecoration: "none",
                    color: "primary.main",
                    "&:hover": {
                      textDecoration: "underline",
                    },
                  }}
                >
                  Първата онлайн карта на читалищата в България
                </Link>
               {" "} и идентифицираните „бели петна“ в официалната отчетност.
              </Typography>
            </Box>

            <Box component="li" sx={{ mb: 2 }}>
              <Typography>
                <strong>Географско разпределение и персонал:</strong> Анализ на
                обхвата на мрежата и капацитета на хората, които стоят зад
                читалищната дейност.
              </Typography>
            </Box>

            <Box component="li" sx={{ mb: 2 }}>
              <Typography>
                <strong>Финансов профил:</strong> Преглед на държавната субсидия
                и финансовите отчети (НСИ и ТР/ЮЛНЦ), поставящ въпроси за
                евентуални диспропорции при разпределението на ресурсите.
              </Typography>
            </Box>

            <Box component="li" sx={{ mb: 2 }}>
              <Typography>
                <strong>Социален контекст:</strong> Връзката между наличието на
                читалища и показатели като възрастовата структура на населението
                по общини.
              </Typography>
            </Box>
          </Box>
        </Box>

        <Typography
          paragraph
          sx={{
            fontStyle: "italic",
            borderLeft: "4px solid #1976d2",
            pl: 2,
            py: 1,
            backgroundColor: "rgba(25, 118, 210, 0.05)",
          }}
        >
          Докладът е предназначен да служи като обективна основа за вземане на
          решения и като покана за структуриран дебат между читалищата, общините
          и държавата.
        </Typography>

        <Box sx={{ mt: 4, display: 'flex', justifyContent: 'center' }}>
          <Button 
            variant="contained" 
            size="large"
            startIcon={<PictureAsPdf />}
            href={doklad}
            download={"Doklad_2026.pdf"}
            sx={{ 
              px: 4, 
              py: 1.5,
              fontWeight: 600,
              fontSize: '1.1rem'
            }}
          >
            Изтеглете пълния доклад в PDF формат
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default ReportPage;
